<template>
  <transition name="modal">
    <div :class="['modal-mask', className || '']">
      <div class="modal-wrapper">
        <div class="modal-container">
          <button class="modal-close-btn" type="button" @click="$emit('close')">
            <template v-if="isDesktop">
              x
            </template>
            <template v-else>
              schließen
              <i class="far fa-times-circle"></i>
            </template>
          </button>
          <div class="modal-content">
            <div class="modal-header">
              <slot name="header" />
            </div>
            <div class="modal-body">
              <slot name="body" />
            </div>
            <div class="modal-footer">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['className'],
  computed: {
    isDesktop() {
      return window.innerWidth > 990;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  position: absolute;
  top: 3.125rem;
  left: 50%;
  width: 100%;
  max-width: 850px;
  padding: 0 1.25rem;
  transform: translate(-50%, 0);
}

.modal-container {
  position: relative;
  width: 100%;
  max-width: 852.5rem;
  margin: 0 auto;
  padding: 3.75rem 1.25rem 1.875rem;
  background-color: #fff;
  border-radius: 0.125rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-content {
  max-height: 60vh;
  max-width: 52.5rem;
  margin: 0 auto;
  overflow: auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-close-btn {
  position: absolute;
  right: 1.25rem;
  top: 1.25rem;
  font-size: 0.875rem;
  color: $red;
  &:hover {
    opacity: 0.8;
  }
  i {
    padding-left: 0.3125rem;
    color: $red;
  }
}

@include breakpoint(tablet) {
  .modal-container {
    padding: 4.375rem 3.125rem 3.125rem;
  }
}

@include breakpoint(desktop) {
  .modal-container {
    padding: 5rem 3.75rem 3.75rem 4.375rem;
  }
  .modal-close-btn {
    right: 1.5rem;
    top: 1.5rem;
    border-radius: 50%;
    height: 3rem;
    width: 3rem;
    display: block;
    border:0.1rem solid $light-gray;
    text-indent: -9999rem;
    box-shadow:0 0 1rem rgba($darkgray,.3);

    &:before, &:after {
      content:'';
      display: block;
      position: absolute;
      width: 0.1rem;
      height: 2rem;
      background: $main;
      top:.4rem;
      left: 1.3rem;
      transform: rotate(45deg)
    }

    &:after {
      transform:rotate(-45deg);
    }

  }
}
</style>
